import { CampaignsTracker } from 'marketing-tracker';
import appConfig from 'src/utils/appConfig';

const PPF_SHORTLINK = 'my-babbel-product-preview';

export default function() {
  const { goBaseUrl } = appConfig.getMyConfig();
  const campaignsTracker = new CampaignsTracker({ host: goBaseUrl });
  campaignsTracker.trackPageview(PPF_SHORTLINK);
}
